import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  persistCombineReducers,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import addOnsReducer from "../redux/addOn/addOnSlice";
import guestReducer from "../redux/guest/guestSlice";
import propertyReducer from "../redux/property/propertySlice";

const persistConfig = {
  key: "root",
  storage,
  // You can still exclude specific reducers if needed later using blacklist
  // blacklist: ['someReducer']
};

// Create a persisted root reducer that combines all reducers
const rootReducer = {
  addOn: addOnsReducer,
  guest: guestReducer,
  property: propertyReducer,
};

const persistedReducer = persistCombineReducers(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/REGISTER",
        ],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
